module.exports = __webpack_public_path__ + "static/media/AcuraofRamsey_Logo.6663a3d9.png";